import React from 'react'
import { ColumnDef } from '@tanstack/react-table'
import ActionButtons from './ActionButtons'

interface Sections {
	_id: string
	name: string
	description: string
	questionCount: number
	createdBy: string
}

export const SectionsDataColumn = (onSuccess: () => void): ColumnDef<Sections>[] => [
	{
		accessorKey: 'name',
		header: 'Section Name',
		cell: ({ row }) => <div className="w-[80px]"> {row.getValue<string>('name')}</div>
	},
	{
		accessorKey: 'description',
		header: 'Description',
		cell: ({ row }) => (
			<div className="w-[80px] text-wrap">{row.getValue<string>('description')}</div>
		)
	},
	{
		accessorKey: 'questionCount',
		header: 'No of Questions',
		cell: ({ row }) => (
			<div className="w-[80px]">{row.getValue<number>('questionCount')}</div>
		)
	},
	{
		header: 'Actions',
		cell: ({ row }) => (
			<ActionButtons
				_id={row.original._id}
				createdBy={row.original.createdBy}
				rowData={row.original}
				onDeleteSuccess={onSuccess}
				onEditSuccess={onSuccess}
			/>
		)
	}
]
